import {
  Radio,
  RadioGroup,
  RadioGroupOnChangeData,
} from '@fluentui/react-components';
import React from 'react';
import { IntlShape, useIntl } from 'react-intl';

import { useCommand, useSelector } from '@tdp';
import { Flex } from '@tdp/common/fluentV9MigrationComponents';

import { ThemePreference } from './abstractions';
import { themeSlice } from './slice';

const themeLocalizedStrings = (intl: IntlShape) => ({
  changeTheme: intl.formatMessage({
    defaultMessage: 'Change theme',
    description: 'Change theme display text',
  }),
  themesText: intl.formatMessage({
    defaultMessage: 'Themes',
    description: 'Themes',
  }),
  defaultThemeText: intl.formatMessage({
    defaultMessage: 'System Default',
    description: 'Display text for default theme.',
  }),
  lightThemeText: intl.formatMessage({
    defaultMessage: 'Light',
    description: 'Display text for light theme.',
  }),
  darkThemeText: intl.formatMessage({
    defaultMessage: 'Dark',
    description: 'Display text for dark theme.',
  }),
  highContrastText: intl.formatMessage({
    defaultMessage: 'High Contrast',
    description: 'Display text for high contrast theme.',
  }),
  closeLabel: intl.formatMessage({
    defaultMessage: 'close',
    description: 'close',
  }),
});

export const ThemeControl = () => {
  const intl = useIntl();
  const currentTheme = useSelector(themeSlice.selectors.getThemePreference);
  // Formatted Strings
  const formattedStrings = themeLocalizedStrings(intl);
  const updateTheme = useCommand(
    (commands) => commands.themeCommands.setPreferredTheme
  );

  // Event Handlers
  const handleThemeChange = (
    ev: React.FormEvent<HTMLDivElement>,
    data: RadioGroupOnChangeData
  ) => {
    updateTheme({ theme: data.value as ThemePreference });
  };

  return (
    <Flex id="themeControl">
      <RadioGroup
        layout="vertical"
        value={currentTheme}
        onChange={handleThemeChange}
      >
        <Radio
          value={'default'}
          label={formattedStrings.defaultThemeText}
          key="default"
        />
        <Radio
          value={'light'}
          label={formattedStrings.lightThemeText}
          key="light"
        />
        <Radio
          value={'dark'}
          label={formattedStrings.darkThemeText}
          key="dark"
        />
        <Radio
          value={'contrast'}
          label={formattedStrings.highContrastText}
          key="hc"
        />
      </RadioGroup>
    </Flex>
  );
};
